export default "__VITE_ASSET__CYttL0yd__"